import React from "react";
import { connect } from 'react-redux';
import { Field, reduxForm, stopSubmit, formValueSelector } from "redux-form";
import { Form, FormGroup, Label, Alert } from "reactstrap";

import TextInput from "../../system/fields/TextInput";
import SelectDropdown from "../../system/fields/SelectDropdown";
import FileUpload from "../../system/fields/FileUpload";
import StarRating from "../../system/fields/StarRating";
import Switch from '../../system/fields/Switch';

import * as validations from "../../system/utils/Validation";
import Wysiwyg from "../../system/fields/Wysiwyg";

let EditForm = (props, { fields }) => {
  const { handleSubmit, mode, featured } = props;
  return (
    <section className="edit-form">
      <Form onSubmit={handleSubmit}>
        <section className="form-section">
          <div className="row">
            <FormGroup className="col-12 col-sm-6">
              <Label htmlFor="email">Featured</Label>
              <Field
                name="featured"
                component={Switch}
                type="text"
              />
            </FormGroup>
            {featured &&
              <FormGroup className="col-12 col-sm-6">
                <Label htmlFor="email">Order</Label>
                <Field
                  name="order"
                  component={TextInput}
                  type="number"
                />
              </FormGroup>
            }
          </div>
          <div className="row">
            <FormGroup className="col-12 col-sm-6">
              <Label htmlFor="email">Name</Label>
              <Field
                name="name"
                component={TextInput}
                placeholder="Deal Type Name"
                type="text"
                validate={validations.required}
                autoFocus={true}
              />
            </FormGroup>
            <FormGroup className="col-12 col-sm-6">
              <Label htmlFor="email">URL</Label>
              <Field
                name="slug"
                component={TextInput}
                placeholder="url"
                type="text"
                validate={validations.required}
              />
            </FormGroup>
          </div>

          {/* <div className="row">
            <FormGroup className="col-12">
              <Label htmlFor="email">Title</Label>
              <Field
                name="title"
                component={Wysiwyg}
                type="text"
                validate={validations.required}
              />
            </FormGroup>
          </div> */}
          <div className="row">
            <FormGroup className="col-12">
              <Label htmlFor="email">Description</Label>
              <Field
                name="description"
                component={Wysiwyg}
                type="text"
                validate={validations.required}
              />
            </FormGroup>
          </div>
          <div className="row">
            <FormGroup className="col-12">
              <Label htmlFor="email">Summary</Label>
              <Field
                name="summary"
                component={Wysiwyg}
                type="text"

              />
            </FormGroup>
          </div>
          <div className="row">
            <FormGroup className="col-12">
              <Label htmlFor="email">Page Description</Label>
              <Field
                name="page_description"
                component={Wysiwyg}
                type="text"

              />
            </FormGroup>
          </div>

          {/* 
          <div className="row">
            <FormGroup className="col-12">
              <Label htmlFor="email">Summary</Label>
              <Field
                name="summary"
                component={Wysiwyg}
                type="text"
                validate={validations.required}
              />
            </FormGroup>
          </div> */}

          <div className="row">
            <FormGroup className="col-12">
              <Label htmlFor="email">Banner Image</Label>
              <Field
                name="banner_image"
                component={FileUpload}
                multiple={false}
                files={false}
                images={true}
                type="text"
                className="form-control"
                validate={validations.required}
              />
            </FormGroup>
          </div>
        </section>
      </Form>

      {props.submitFailed && (
        <div className="error-container">
          <Alert color="danger">
            <strong>There are errors in your form.</strong>
            <br />Please check before submitting again.
          </Alert>
        </div>
      )}
    </section>
  );
};

EditForm = reduxForm({
  form: "DealTypeForm",
  onChange: (values, dispatch, props) => {
    if (props.error || props.submitFailed) { dispatch(stopSubmit("DealTypeForm")) }
  }
})(EditForm);

const selector = formValueSelector('DealTypeForm');

const mapStateToProps = state => ({
  featured: selector(state, 'featured')
});

export default connect(mapStateToProps)(EditForm);



// WEBPACK FOOTER //
// ./src/containers/DealTypes/Form.jsx